<div [class]="'message-parent-container ly-sp-xs-right ly-sp-s-bottom ' + this.getStyleClass()" *ngIf="this.getHidden() === false">
    <div *ngIf="this.getStyle() === messageStyle.unicolor && (!!this.getHidden()) === false"
        [ngClass]="{
            'large-message': size === messageSize.large,
            'tall-message': size === messageSize.tall,
            'th-bg-confirmation': type === messageType.success,
            'th-bg-alert': type === messageType.error,
            'justify-content-center': size === messageSize.large,
            'position-relative': visualization === messageVisualization.block,
            'message-float': visualization === messageVisualization.float,
            'float-message-m': visualization === messageVisualization.float && isMedium,
            'float-message-s': visualization === messageVisualization.float && isSmall,
            'float-message-xs': visualization === messageVisualization.float && isExtraSmall,
            'full-screen-message': this.isFullScreen && (isMedium || isSmall)
        }"
        class="d-flex align-items-center message-container">
    
        <!-- icon -->
        <div class="icon-container">
            <object *ngIf="this.getType() === messageType.success"
                    [data]="this.getMessageIcon() | safeUrl"
                    type="image/svg+xml"
                    [width]="this.iconWidth"
                    [height]="this.iconHeight">
            </object>
            <object *ngIf="this.getType() === messageType.error"
                    [data]="this.getMessageIcon() | safeUrl"
                    type="image/svg+xml"
                    [width]="this.iconWidth"
                    [height]="this.iconHeight">
            </object>
            
        </div>



        <!-- text -->
        <div class="message-text-container ly-sp-s-top ly-sp-s-bottom">
            <span class="th-text-white bs-paragraph message-text">{{this.getMessage()}}</span>
        </div>

        <div class="close-container cursor-pointer" *ngIf="this.getCanBeClosed()" (click)="this.hideMessage()">
         <i class="fa fa-times th-text-white"></i>
        </div>
    </div>

    <!-- multicolor message -->
    <div *ngIf="this.getStyle() === messageStyle.multicolor && (!!this.getHidden()) === false" 
        class="large-message d-flex th-bg-white message-container multicolor-container">
        
        <!-- icon container -->
        <div class="multicolor-icon-container d-flex justify-content-center align-items-center"
                [class.th-bg-confirmation]="this.getType() === messageType.success"
                [class.th-bg-alert]="this.getType() === messageType.error">
                <object *ngIf="this.getType() === messageType.success"
                        [data]="this.getMessageIcon() | safeUrl"
                        type="image/svg+xml"
                        [width]="this.iconWidth"
                        [height]="this.iconHeight">
                </object>
                <object *ngIf="this.getType() === messageType.error"
                        [data]="this.getMessageIcon() | safeUrl"
                        type="image/svg+xml"
                        [width]="this.iconWidth"
                        [height]="this.iconHeight">
                </object>
        </div>

        <!-- text container -->
        <div class="d-flex ly-sp-s-top ly-sp-s-bottom">
            <span class="th-text-main bs-paragraph message-text message-text-weight">{{this.getTitle()}}</span>
            <span class="th-text-gray-paragraphs bs-paragraph ly-sp-xs-left" *ngIf="this.getIsMedium() || (this.getIsExtraSmall() && this.getTitle() === '') ||
            (this.getIsSmall() && this.getTitle() === '')">{{this.getMessage()}}</span>
        </div>

        <!-- actions container -->
        <div class="actions-container ms-auto cursor-pointer d-flex justify-content-center align-items-center" (click)="this.executeEvent()">
            <div class="d-flex justify-content-center align-items-center">
                <div class="th-text-main bs-paragraph message-text message-text-weight">
                    <span>{{this.getActionText()}}</span>
                </div>
                <div>
                    <i [class]="this.getActionIcon()" class="th-text-confirmation"></i>
                </div>
            </div>
        </div>

    </div>
</div>